import classNames from 'classnames'
import React from 'react'

const InputWithLabel = React.forwardRef((props: any, ref: any) => {
  const {
    textarea,
    clx,
    label,
    placeholder,
    disabled = false,
    defaultValue,
    style,
    onBlur,
    onChange,
    ...others
  } = props
  return (
    <div className={classNames(clx, 'flex flex-col text-left')}>
      {label && <div className="text-black">{label}</div>}
      {textarea ? (
        <textarea
          {...others}
          ref={ref}
          rows={5}
          onBlur={onBlur ? onBlur : null}
          onChange={onChange ? onChange : null}
          disabled={disabled}
          defaultValue={defaultValue ? defaultValue : ''}
          style={{ borderRadius: 4, ...style }}
          className="mt-4 p-16"
          placeholder={placeholder}
        />
      ) : (
        <input
          {...others}
          ref={ref}
          onBlur={onBlur ? onBlur : null}
          onChange={onChange ? onChange : null}
          defaultValue={defaultValue ? defaultValue : ''}
          disabled={disabled}
          style={{ borderRadius: 4, ...style }}
          className="mt-4 border border-gray-300 px-16 py-12 font-medium"
          placeholder={placeholder}
        />
      )}
    </div>
  )
})

InputWithLabel.displayName = 'InputWithLabel'

export default InputWithLabel
